<template>
  <layout-auth>
    <v-container class="py-10">
      <v-row>
        <v-col cols="12">
          <h1 class="text-h4 font-weight-light py-5">
            {{ $t("invoices.consultaFacturas") }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p>{{ $t("invoices.ListadoFacturasRealizadas") }}</p>
        </v-col>
      </v-row>

      <v-row style="align-items: center">
        <v-col cols="8">
          <h1 class="text-h5 font-weight-light">
            {{ $t("invoices.listadoFacturas") }}
          </h1>
        </v-col>

        <v-col>
          <v-btn
            plain
            @click="MostarFitro = !MostarFitro"
            :color="entityConfig.primaryColor"
            class="float-end m-2"
          >
            <v-icon left> mdi-tune </v-icon>
            {{ $t("invoices.filtrar") }}
          </v-btn>
          <v-btn
            plain
            :color="entityConfig.primaryColor"
            @click="print"
            class="float-end m-2"
          >
            <v-icon left> mdi-printer-outline </v-icon>
            {{ $t("supplierData.print") }}
          </v-btn>

          <v-btn
            plain
            :color="entityConfig.primaryColor"
            @click="downloadExcel"
            class="float-end m-2"
          >
            <v-icon left> mdi-microsoft-excel </v-icon>
            Excel
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!------------------------------- init Slot filtrar --------------------------->

    <v-container v-show="MostarFitro">
      <v-divider :color="entityConfig.primaryColor"></v-divider>
      <v-form v-model="formulario" autocomplete="off" ref="formulario">
        <v-row>
          <v-col cols="10" sm="12" md="12" lg="8">
            <label class="label-negrita py-5">{{
              $t("invoices.empresaEmisor")
            }}</label>
            <v-autocomplete
              placeholder="Nombre EMPRESA EMISOR"
              :color="entityConfig.primaryColor"
              :items="invoicesListClients"
              :item-color="entityConfig.primaryColor"
              dense
              no-data-text=""
              item-text="name"
              item-value="numClient"
              outlined
              @change="filterNumeroClients"
              v-model="form.listClients"
            ></v-autocomplete>
          </v-col>
          <v-col cols="2" sm="4" md="4" lg="4">
            <v-icon @click="MostarFitro = !MostarFitro" class="float-end" left>
              mdi-close
            </v-icon>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="6" lg="2">
            <label class="label-negrita py-5">{{
              $t("invoices.fechaVencimiento")
            }}</label>

            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computedDateFormattedInit"
                  :rules="[rules.dateFrom]"
                  readonly
                  outlined
                  dense
                  :placeholder="$t('invoices.from')"
                  :color="entityConfig.primaryColor"
                  persistent-hint
                  append-icon="mdi-calendar"
                  @blur="dateInit = parseDateInit(dateInit)"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :max="DateMax"
                :min="DateMin"
                :locale="$i18n.locale"
                :color="entityConfig.primaryColor"
                v-model="dateInit"
                @input="filterFechaDesde"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="2">
            <label class="label-negrita py-7"></label>

            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  readonly
                  outlined
                  dense
                  :placeholder="$t('invoices.to')"
                  v-model="computedDateFormattedEnd"
                  :color="entityConfig.primaryColor"
                  persistent-hint
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  :rules="[rules.dateFrom]"
                  @blur="dateEnd = parseDateEnd(dateEnd)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :max="DateMax"
                :min="DateMin"
                :locale="$i18n.locale"
                :color="entityConfig.primaryColor"
                v-model="dateEnd"
                no-title
                @input="filterFechaHasta"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="2">
            <label class="label-negrita py-5">{{
              $t("invoices.importeFactura")
            }}</label>
            <v-currency-field
              maxlength="18"
              :rules="[rules.amountFrom, rules.quinceEnterosInit]"
              :color="entityConfig.primaryColor"
              dense
              @input="filterImporteDesde"
              @keyup="$refs.formulario.validate()"
              outlined
              :placeholder="$t('invoices.from')"
              appendIcon="mdi-currency-eur"
              append-icon="mdi-euro"
              v-model="form.invoiceAmountInit"
            />
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="2">
            <label class="label-negrita py-7"></label>
            <v-currency-field
              maxlength="18"
              :rules="[rules.amountFrom, rules.quinceEnterosEnd]"
              :color="entityConfig.primaryColor"
              dense
              @input="filterImporteHasta"
              @keyup="$refs.formulario.validate()"
              outlined
              :placeholder="$t('invoices.to')"
              appendIcon="mdi-currency-eur"
              append-icon="mdi-euro"
              v-model="form.invoiceAmountEnds"
            />
          </v-col>

          <v-col cols="12" sm="12" lg="4" v-show="entityConfig.tipoConfirming">
            <label class="label-negrita py-5">{{
              $t("invoices.tipoConfirming")
            }}</label>
            <v-select
              :color="entityConfig.primaryColor"
              :item-color="entityConfig.primaryColor"
              :items="tipoConfirming"
              dense
              outlined
              item-text="name"
              item-value="value"
              placeholder="Normal"
              v-model="form.tipoConfirming"
              @change="filterTipoConfirming"
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" lg="4">
            <label class="label-negrita py-5">{{
              $t("invoices.situacionFactura")
            }}</label>
            <v-select
              :color="entityConfig.primaryColor"
              :item-color="entityConfig.primaryColor"
              :items="situacionFactura"
              dense
              outlined
              item-text="name"
              item-value="value"
              :placeholder="$t('invoices.everySituation')"
              v-model="form.situacionFactura"
              @change="filterSituacionFactura"
            ></v-select>
          </v-col>
        </v-row>

        <v-row class="pb-5">
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              :style="`color: ${entityConfig.secondaryColor}`"
              @click="resetPaginationAndSearch()"
              depressed
              :color="entityConfig.primaryColor"
              :disabled="!formIsValid"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("invoices.filtrar") }}
            </v-btn>

            <v-btn
              @click="limpiarFiltros"
              outlined
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("invoices.quitarFiltros") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <!------------------------------- end Slop filtrar --------------------------->
    <v-container>
      <v-divider :color="entityConfig.primaryColor"></v-divider>
      <error-table :erroCode="valCode" :hidden="!noData" />
      <v-row>
        <v-col :hidden="noData">
          <v-data-table
            fixed-header
            no-data-text="No hay datos que mostrar"
            class="firt-col-right-margin"
            :items-per-page="itemsPerPage"
            :headers="headers"
            :items="invoicesList"
            hide-default-footer
          >
            <template v-slot:item.invoiceStatus="{ item }">
              <span class="chip">{{ item.invoiceStatus }}</span>
            </template>

            <template v-slot:item.wayToPay="{ item }">
              {{ traducirFormaPago(item.wayToPay) }}
            </template>

            <template v-slot:item.invoiceDate="{ item }">
              {{ dataFormatter.dateFormatter(item.invoiceDate, $i18n.locale) }}
            </template>
            <template v-slot:item.invoiceExpirationDate="{ item }">
              {{
                dataFormatter.dateFormatter(
                  item.invoiceExpirationDate,
                  $i18n.locale
                )
              }}
            </template>

            <template v-slot:item.nominalAmount="{ item }">
              {{ dataFormatter.currencyFormatter(item.nominalAmount) }}
            </template>

            <template v-slot:item.nominalAmountFinanced="{ item }">
              {{ dataFormatter.currencyFormatter(item.nominalAmountFinanced) }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <overlay :visible="spinner" :opacity="1"></overlay>
    </v-container>
    <v-container>
      <div class="text-right pb-10" :hidden="noData">
        <v-row>
          <v-col>
            <paginator
              :hasPrev="hasPrev"
              :hasNext="hasNext"
              :pageNumber="pageNumber"
              @pageone="goToPageOne()"
              @prev="prevPage()"
              @next="nextPage()"
            ></paginator>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </layout-auth>
</template>

<script>
import Paginator from "../../components/layouts/paginator.vue";
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";
import xlsx from "json-as-xlsx";
import dataFormatter from "../../plugins/dataFormatter";

import ErrorTable from "../../components/layouts/error-table.vue";

export default {
  components: { LayoutAuth, Overlay, Paginator, ErrorTable },
  data(vm) {
    return {
      dataFormatter: dataFormatter,
      dateInit: "",
      dateEnd: "",
      dateFormattedInit: vm.formatDateInit(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      ),

      dateFormattedEnd: vm.formatDateEnd(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      ),
      hasNext: false,
      paginationIndex: 0,
      itemsPerPage: 0,
      pageIndexItems: [],
      formulario: false,
      entityConfig: {},
      MostarFitro: false,
      spinner: true,
      menu1: false,
      menu2: false,
      form: {
        listClients: "",
        computedDateFormattedInit: "",
        computedDateFormattedEnd: "",
        invoiceAmountInit: "",
        invoiceAmountEnds: "",
        tipoConfirming: "",
        situacionFactura: "",
      },

      query: {
        codigoEntidad: "",
        tipoConfirming: "",
      },

      tipoConfirming: [
        { value: "N", name: this.$t("invoices.normal") },
        { value: "D", name: this.$t("invoices.gastoDeudor") },
      ],

      situacionFactura: [
        { value: 0, name: this.$t("invoices.everySituation") },
        { value: 1, name: this.$t("invoices.anticipated") },
        { value: 2, name: this.$t("invoices.partialyAnticipated") },
        { value: 3, name: this.$t("invoices.pendingPayment") },
        { value: 4, name: this.$t("invoices.paidOnExpiration") },
      ],
      headers: [
        {
          text: this.$t("invoices.invoiceNumber"),
          sortable: false,
          value: "invoiceNumberExt",
        },
        {
          text: this.$t("invoices.client"),
          sortable: false,
          value: "customerName",
        },
        {
          text: this.$t("invoices.situation"),
          sortable: false,
          value: "invoiceStatus",
        },
        {
          text: this.$t("invoices.date"),
          sortable: false,
          value: "invoiceDate",
          align: "right",
        },
        {
          text: this.$t("invoices.expDate"),
          sortable: false,
          value: "invoiceExpirationDate",
          align: "right",
        },
        {
          text: this.$t("invoices.nominalAmount"),
          sortable: false,
          value: "nominalAmount",
          align: "right",
        },
        {
          text: this.$t("invoices.nominalAmountFinanced"),
          sortable: false,
          value: "nominalAmountFinanced",
          align: "right",
        },
        {
          text: this.$t("invoices.paymentMethod"),
          sortable: false,
          value: "wayToPay",
          width: "10em",
        },

        {
          text: this.$t("invoices.ibanAbono"),
          sortable: false,
          value: "iban",
          width: "10em",
        },
      ],
      listClient: [],
      invoicesList: [],
      noData: false,
      invoices: [
        {
          iban: "",
          description: "",
        },
      ],
      valCode: 0,
      invoicesListClients: [],
      invoicesClients: [],
      userId: "",
      userdata: {},
      rules: {
        quinceEnterosInit: () =>
          this.form.invoiceAmountInit < 1000000000000000 ||
          "El importe no debe contener mas de quince enteros y dos decimales",
        quinceEnterosEnd: () =>
          this.form.invoiceAmountEnds < 1000000000000000 ||
          "El importe no debe contener mas de quince enteros y dos decimales",
        required: (v) => !!v || "Este campo es requerido..",
        dateFrom: () => {
          if (this.dateInit !== "" && this.dateEnd !== "") {
            var fecha1 = new Date(this.dateInit);
            var fecha2 = new Date(this.dateEnd);
            return (
              fecha1.getTime() <= fecha2.getTime() ||
              "Fecha de vencimiento desde debe ser menor a fecha hasta."
            );
          }
          return true;
        },
        amountFrom: () => {
          if (
            this.form.invoiceAmountInit !== "" &&
            this.form.invoiceAmountEnds !== "" &&
            this.form.invoiceAmountInit !== null &&
            this.form.invoiceAmountEnds !== null
          ) {
            return (
              this.form.invoiceAmountInit <= this.form.invoiceAmountEnds ||
              "El importe hasta debe ser mayor al importe desde."
            );
          }
          return true;
        },
      },
    };
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;

    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    this.userdata = JSON.parse(sessionStorage.getItem("userData"));
    this.userId = this.userdata.supplierId.trim();

    this.query.tipoConfirming = "N";
    this.query.estadoFactura = 0;
    this.query.codigoEntidad = sessionStorage.getItem("codNrbeEn");
    this.get_client_invoice_select();
    this.get_list_invoice();
  },

  computed: {
    pageNumber() {
      return this.paginationIndex + 1;
    },
    DateMax() {
      const dateFechaMax = new Date();
      dateFechaMax.setDate(dateFechaMax.getDate() + 365);
      return dateFechaMax.toISOString().substr(0, 10);
    },
    DateMin() {
      const dateFechaMin = new Date();
      dateFechaMin.setDate(dateFechaMin.getDate() - 365);
      return dateFechaMin.toISOString().substr(0, 10);
    },
    formIsValid() {
      return this.formulario;
    },
    computedDateFormattedInit() {
      return this.formatDateInit(this.dateInit);
    },

    computedDateFormattedEnd() {
      return this.formatDateEnd(this.dateEnd);
    },

    hasPrev() {
      return this.paginationIndex > 0;
    },
  },
  watch: {
    dateInit() {
      this.dateFormattedInit = this.formatDateInit(this.dateInit);
    },

    dateEnd() {
      this.dateFormattedEnd = this.formatDateEnd(this.dateEnd);
    },
  },

  methods: {
    traducirFormaPago(val) {
      if (val === "T") return "Transferencia";
      if (val === "C") return "Cheque";
      return val;
    },

    print() {
      window.print();
    },
    downloadExcel() {
      let data = [
        {
          sheet: this.$t("invoices.listadoFacturas"),
          columns: [
            { label: "Nº DE FACTURA", value: "invoiceNumberExt" },
            { label: "CLIENTE PAGADOR", value: "customerName" },
            { label: "SITUACIÓN", value: "invoiceStatus" },
            { label: "FECHA FACTURA", value: "invoiceDate" },
            { label: "FECHA VTO.", value: "invoiceExpirationDate" },
            { label: "IMP. FACTURA", value: "nominalAmount" },
            { label: "IMP. ANTICIPADO", value: "nominalAmountFinanced" },

            {
              label: "FORMA DE PAGO",
              value: (v) => this.traducirFormaPago(v.wayToPay),
            },

            { label: "IBAN DE ABONO", value: "iban" },
          ],
          content: this.invoicesList,
        },
      ];
      let settings = { fileName: this.$t("invoices.listadoFacturas") };
      xlsx(data, settings);
    },

    filterSituacionFactura(val) {
      this.query.estadoFactura = val;
    },
    filterTipoConfirming(val) {
      this.query.tipoConfirming = val;
    },

    filterImporteHasta() {
      this.query.impHasta = this.form.invoiceAmountEnds;
    },
    filterImporteDesde() {
      this.query.impDesde = this.form.invoiceAmountInit;
    },

    filterFechaHasta(val) {
      this.menu2 = false;
      this.query.fechaHasta = val;
      this.$refs.formulario.validate();
    },

    filterFechaDesde(val) {
      this.menu1 = false;
      this.query.fechaDesde = val;
      this.$refs.formulario.validate();
    },

    filterNumeroClients() {
      this.query.numCliente = this.form.listClients;
    },

    limpiarFiltros() {
      this.query = {};
      this.query.tipoConfirming = "N";
      this.query.codigoEntidad = sessionStorage.getItem("codNrbeEn");

      this.form = {
        listClients: "",
        computedDateFormattedInit: "",
        computedDateFormattedEnd: "",
        invoiceAmountInit: null,
        invoiceAmountEnds: null,
        situacionFactura: "",
      };
      this.dateInit = "";
      this.dateEnd = "";
    },

    formatDateInit(dateInit) {
      if (!dateInit) return null;

      const [year, month, day] = dateInit.split("-");

      return `${day}/${month}/${year}`;
    },
    parseDateInit(dateInit) {
      if (!dateInit) return null;

      const [day, month, year] = dateInit.split("/");
      this.$refs.formulario.validate();
      return `${day}-${month}-${year}`;
    },

    formatDateEnd(dateEnd) {
      if (!dateEnd) return null;

      const [year, month, day] = dateEnd.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateEnd(dateEnd) {
      if (!dateEnd) return null;

      const [day, month, year] = dateEnd.split("/");
      return `${day}-${month}-${year}`;
    },

    async nextPage() {
      this.query.paginationItem = this.pageIndexItems[this.paginationIndex++];
      await this.get_list_invoice();
    },
    async goToPageOne() {
      this.paginationIndex = 1;
      await this.prevPage();
    },
    async prevPage() {
      this.paginationIndex--;
      if (this.paginationIndex > 0) {
        this.query.paginationItem =
          this.pageIndexItems[this.paginationIndex - 1];
      } else {
        delete this.query.paginationItem;
      }
      await this.get_list_invoice();
    },
    async resetPaginationAndSearch() {
      delete this.query.paginationItem;
      this.paginationIndex = 0;
      this.pageIndexItems = [];
      await this.get_list_invoice();
    },

    async get_list_invoice() {
      this.invoicesList = [];
      const qs = Object.keys(this.query)
        .filter(key => this.query[key])
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(this.query[key])}`
        )
        .join("&");
      try {
        this.userdata = JSON.parse(sessionStorage.getItem("userData"));
        this.userId = this.userdata.supplierId.trim();
        this.spinner = true;
        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        this.invoices = await Api.get(
          `/proveedores/${this.userId}/facturas/?${qs}`
        );
        this.invoicesList = this.invoices.data.response.invoiceResponseList;
        this.itemsPerPage = this.invoicesList.length;
        this.hasNext = this.invoices.data.response.moreData == 1;
        if (
          !this.pageIndexItems.includes(
            this.invoices.data.response.paginationItem
          )
        ) {
          this.pageIndexItems.push(this.invoices.data.response.paginationItem);
          console.log('pageIndexItems', this.pageIndexItems)
        }
        this.spinner = false;
        this.noData = false;
      } catch (error) {
        this.valCode = error.response.data.code;
        this.noData = true;
      } finally {
        this.spinner = false;
      }
    },
    async get_client_invoice_select() {
      try {
        this.userdata = JSON.parse(sessionStorage.getItem("userData"));
        this.userId = this.userdata.supplierId.trim();
        this.spinner = true;
        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        this.invoicesClients = await Api.get(
          `/proveedores/${this.userId}/clientes`
        );
        this.invoicesListClients = this.invoicesClients.data.response;
        this.spinner = false;
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },
  },
};
</script>
